<script setup>
import { useInvestmentProcessDataState } from '../../../utilities/investment-process/useInvestmentProcess'
import { storeToRefs } from 'pinia'
import { getCampaignData } from '../../../utilities/investment-process/useCampaign'

const store = useInvestmentProcessDataState()
const { savingsPlan } = storeToRefs(store)
</script>

<template>
    <div class="relative flex items-start pt-4">
        <div class="flex h-6 items-center">
            <input
                id="savingsPlane"
                v-model="savingsPlan"
                aria-describedby="savings-plan-description"
                name="savingsPlane"
                type="checkbox"
                class="h-4 w-4 rounded border-gray-300 text-primary focus:ring-primary" />
        </div>
        <div class="ml-3 text-sm leading-6">
            <label for="savingsPlane" class="font-semibold text-gray-900">{{
                $t('investment_process.accept_savings_plan')
            }}</label>
        </div>
    </div>
    <div
        v-if="getCampaignData().asset_data.savings_plan_description !== null"
        class="mt-2 w-full whitespace-pre-wrap rounded border border-gray-300 bg-gray-50 p-2 text-xs">
        {{ getCampaignData().asset_data.savings_plan_description }}
    </div>
</template>

<style scoped></style>
